import {useEffect, useState} from "react";
import {getMembers} from "../api/RestCallHelper";
import {FeedbackReducerActionType, useFeedbackDispatch} from "../utils/FeedbackContext";
import FetchState from "../api/FetchState";
import {useHistory, useLocation} from "react-router-dom";

export default function useFetchMembersDropdown(dropdownOpen) {

    let location = useLocation();
    let history = useHistory();

    const dispatch = useFeedbackDispatch();
    const [fetchState, setFetchState] = useState(FetchState.LOADING);

    const [dropdownData, setDropdownData] = useState([]);
    const loading = dropdownOpen && dropdownData.length === 0;

    const close = (event, reason) => {
        console.log("In useFetchMembersDropdown close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    useEffect(() => {

        let active = true;

        if (!loading) {
            return undefined;
        }

        // send the actual request
        getMembers(setDropdownData, active, dispatch, setFetchState, close, history, location);

        return () => {
            active = false;
        };

    }, [loading]);

    return [dropdownData, loading]

}